import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useCountries = defineStore('countries', () => {
    const countries = ref([])
    const loading = ref(false)
    const loaded = ref(false)

    const fetch = async () => {
        if (loaded.value || loading.value) return

        loading.value = true
        try {
            const response = await window.fetch('/wp-json/formychat/contents', {
                method: 'GET',
                headers: {
                    'X-WP-Nonce': window.formychat_admin_vars?.rest_nonce || ''
                }
            })

            const result = await response.json()

            if (result.countries) {
                countries.value = result.countries
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(country => ({
                        value: country.code,
                        label: `<span>${country.flag} (${country.code})</span> ${country.name}`,
                        name: `<span>${country.flag}</span> ${country.code}`
                    }))
            }
            loaded.value = true
        } catch (error) {
            console.error('Error fetching countries:', error)
        } finally {
            loading.value = false
        }
    }

    return {
        countries,
        loading,
        loaded,
        fetch
    }
})
